import { exec } from "jadelet"
export default exec(["pattern",{"class":[{"bind":"class"}],"click":{"bind":"click"}},[{"bind":"preview"}]])